import { call, put, takeEvery } from "redux-saga/effects";
import {
  analyzeImageRequest,
  analyzeImageSuccess,
  analyzeImageFailure,
} from "./slice";
import { fetchImageAnalyseApi } from "../../services/quickOrder/quickOrder.api";
import { SagaIterator } from "@redux-saga/types";
import { updateFileClarity } from "../uploadFile/slice";

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.split(",")[1]);
    };
    reader.onerror = (error) => reject(error);
  });
}

function* analyzeImageSaga(
  action: ReturnType<typeof analyzeImageRequest>
): SagaIterator {
  const file: File = action.payload as any;

  try {
    const response = yield call(fetchImageAnalyseApi, file);

    const isClear = !response?.hasGlareorFlash ? "G" : "B";
    yield put(analyzeImageSuccess({ fileName: file.name, isClear }));
    yield put(
      updateFileClarity({
        fileName: file.name,
        size: file.size,
        imageQuality: isClear,
      })
    );
  } catch (error) {
    yield put(analyzeImageFailure({ fileName: file.name, error }));
  }
}

export function* watchAnalyzeImage(): SagaIterator {
  yield takeEvery(analyzeImageRequest.type, analyzeImageSaga);
}
